<div id="geolocationsMap" class="h-100 map-wrapper shadow-sm position-relative rounded" style="min-height:300px">
  <div id="windy" class="monitor-windy position-absolute rounded"></div>

  @for (marker of markers; track trackByMarkerId(marker)) {
    <div [id]="marker?.chart?.anchorMarkerNg"
      class="geomap-marker-group position-absolute {{preventClickOnPark(marker)}}"
      [class.hidden]="!show">
      <div class="geomap-marker-header">
        <div class="geomap-power-info">
          <div>
            <span class="geomap-power-info__title bold">{{'COMPONENT_LIBRARY.MAP.ACT' | translate }}  </span>
            <span class="bold">{{ marker?.data?.actualPower | convertPower: 'MW' | number: '1.2-2' | customNumberFormat }} MW</span>
          </div>
          <span class="geomap-power-info__title">{{'COMPONENT_LIBRARY.MAP.THEO' | translate }}
            </span><span>{{ marker?.data?.theoreticalPower | convertPower: 'MW' | number: '1.2-2' | customNumberFormat }} MW</span><br>
            <span class="geomap-power-info__title">{{'COMPONENT_LIBRARY.MAP.LOSS' | translate }}
              </span><span>{{ marker?.data?.lostPower | convertPower: 'MW' | number: '1.2-2' | customNumberFormat }} MW</span>
            </div>
          </div>
          <div class="geomap-marker-chart-container" (click)="monitorPortfolioMarkerClicked(marker.chart.anchorMarker)">
            <app-doughnut-status class="geomap-marker-chart"
              [attr.data-marker-id]="marker.id" (chartClick)="chartClicked({marker,event:$event})"
              [markers]="{data: marker.chart.turbineStatusesSums, colors: marker.chart.turbineStatusesColors}">
            </app-doughnut-status>
            <div class="geomap-marker-icon" (click)="markerIconClicked(marker)">
              <div>{{ marker?.data?.ratedPower | convertPower: 'MW' | number: '1.2-2' | customNumberFormat }}</div>
            </div>
          </div>
          <div class="geomap-marker-footer">
            <div class="geomap-marker-parks">
              @for (park of marker?.data?.parks| slice:0:15; track trackByParkName(park)) {
                <div class="geomap-marker-park"
                  (click)="parkIconClicked(park.name, marker.chart.anchorMarker)">
                  <div class="geomap-marker-park-icon">
                    <i
                    class="fas fa-circle" [ngStyle]="{'color': park?.status | colorStatusCode:'color'}"></i>
                    {{park.displayCode}}
                  </div>
                  <app-geomap-marker-park [asset]="park"
                    [data]="marker.data"
                    [subAssets]="selectedParksTurbines"
                    [active]="isActiveParkTooltip(park.name)"
                    (redirectToSubAsset)="turbineClicked($event)"
                    (redirectToAsset)="parkClicked($event)"
                    (changed)="redrawMapClick()"
                    style="cursor: default;">
                  </app-geomap-marker-park>
                </div>
              }
              @if (marker?.data?.parks.length - 15 > 0) {
                <div
                  class="geomap-marker-park-more cursor-default">
                  <div class="geomap-marker-park-icon">
                    + {{ marker?.data?.parks.length - 15 }} more assets
                  </div>
                </div>
              }
            </div>
          </div>
          <div class="geomap-marker-aside">
            @if (isActiveMarkerTooltip(marker.id)) {
              <app-geomap-marker-status
                [subAssets]="selectedStatusTurbines"
                (redirectToSubAsset)="turbineClicked($event)"
                (changed)="redrawMapClick()">
              </app-geomap-marker-status>
            }
          </div>
        </div>
      }

      <ul class="map-header nav d-flex align-items-center position-absolute w-100 p-3"
        [attr.style]="sanitizer.bypassSecurityTrustStyle('width: calc(100% - ' + headerPositionsAdjust + 'px) !important')">
        <li class="nav-item font-weight-bold font-size-normal text-white mr-auto">
          {{ 'COMPONENT_LIBRARY.MAP.TITLE' | translate }}
        </li>
        <li class="nav-item">
          <ng-content select=[resize]></ng-content>
        </li>
      </ul>
    </div>
